import store from '@/store'
import {toast} from "./Notification";
import {findAttributeOnSiteInfo} from './FindAttributeOnSiteInfo'

export const redirectLogin = function (to, from, next) {
    const isAuth = store.getters['User/isAuthenticated'];
    if (isAuth) next({name: "Home"})
    next();
}
export const loginRequired = function (to, from, next) {
    const isAuth = store.getters['User/isAuthenticated'];
    if (!isAuth) next({name: "Login"})
    next();
}

export const isGuest = function (to, from, next) {
    const isAuth = store.getters['User/isAuthenticated'];
    if (isAuth) next({name: "Home"})
    next();
}

export const isVerifiedCellphoneForSmsVerification = function (to, from, next) {
    const isVerifiedCellphone = store.getters['User/isPhoneVerified']
    if (isVerifiedCellphone) next({name: "Profile"})
    next();
}

export const isVerifiedCellphone = function (to, from, next) {

    // each site info orderVerificationAccess mode have some rule and we check them here.

    const isPhoneVerified = store.getters['User/isPhoneVerified']
    const isEmailVerified = store.getters['User/isEmailVerified']
    const orderVerificationAccess = findAttributeOnSiteInfo('orderVerificationAccess');
    if (orderVerificationAccess == 1 && !isEmailVerified) {
        toast('لطفا ایمیل خود را تایید کنید', 'لطفا ایمیل خود را در بخش پروفایل تایید بفرمایید')
        next({name: "Profile"})
    } else if (orderVerificationAccess == 2 && !isPhoneVerified) {
        toast('لطفا شماره تلفن خود را تایید کنید', 'لطفا شماره تلفن خود را در بخش پروفایل تایید بفرمایید')
        next({name: "Profile"})
    } else if (orderVerificationAccess == 3 && (!isPhoneVerified || !isEmailVerified)) {
        toast('لطفا شماره تلفن و ایمیل خود را تایید کنید', 'لطفا شماره تلفن و ایمیل خود را در بخش پروفایل تایید بفرمایید')
        next({name: "Profile"})
    }

    next();
}
export const isVerifiedEmail = function (to, from, next) {
    const isVerifiedEmail = store.getters['User/isEmailVerified']
    if (!isVerifiedEmail) next({name: "Profile"})
    next();
}
export const isRequestCellphoneForgetPassword = function (to, from, next) {
    const cellphoneForForgetPassword = store.getters['Authentication/getCellphoneForForgetPassword'];
    if (cellphoneForForgetPassword === null) next({name: "ForgetPassword"})
    next();
}


export const needPhoneVerification = function (to, from, next) {

    const isPhoneVerified = store.getters['User/isPhoneVerified']
    const isEmailVerified = store.getters['User/isEmailVerified']
    const orderVerificationAccess = findAttributeOnSiteInfo('dashboardVerificationAccess');
    if (orderVerificationAccess == 1 && !isEmailVerified) {
        toast('لطفا ایمیل خود را تایید کنید', 'لطفا ایمیل خود را در بخش پروفایل تایید بفرمایید')
        next({name: "Profile"})
    } else if (orderVerificationAccess == 2 && !isPhoneVerified) {
        toast('لطفا شماره تلفن خود را تایید کنید', 'لطفا شماره تلفن خود را در بخش پروفایل تایید بفرمایید')
        next({name: "Profile"})
    } else if (orderVerificationAccess == 3 && (!isPhoneVerified || !isEmailVerified)) {
        toast('لطفا شماره تلفن و ایمیل خود را تایید کنید', 'لطفا شماره تلفن و ایمیل خود را در بخش پروفایل تایید بفرمایید')
        next({name: "Profile"})
    }

    next()
}

export const isStore = function (to, from, next) {
    const isAuth = !store.getters['User/isUserStore'];
    if (isAuth) next({name: "StoreAccessDenied"})
    next();
}

export const isAdmin = function (to, from, next) {
    const isAuth = !store.getters['User/isAdmin'];
    if (isAuth) next({name: "AccessDenied"})
    next();
}

export const guardsObject = () => {
    return {
        redirectLogin,
        loginRequired,
        isGuest,
        isVerifiedCellphoneForSmsVerification,
        isVerifiedCellphone,
        isVerifiedEmail,
        isRequestCellphoneForgetPassword,
        needPhoneVerification,
        isStore,
        isAdmin,
    }
}